import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Kelebet_Engida',
    title: "<Full Stack Developer & Instructor/>",
    desciption:"Dedicated and efficient Full-stack Agile Developer with an Environmental Science degree  (focusing on remote sensing data analytical skills) from the University of Washington. Have intermediate experience in Python (panda library). Well-rounded professional with communication and organizational skills. I really enjoy using my skill sets to support the entrepreneurial culture of startups and big companies.",
    image: "https://media.licdn.com/dms/image/D4E03AQH3AvkASjhvgQ/profile-displayphoto-shrink_800_800/0/1668991749436?e=2147483647&v=beta&t=UI375hmT1UMheMkBVDG8kbiROLXBtKUoXqoslajYq1Y",
    resumePdf: resume
}
